import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { HIGH_LEVEL_CONFIG } from "./config/high_level_config";
import "moment/locale/en-gb";
import "moment/locale/it";

const resources = {
  en: {
    translation: {
      "TOP MENU ATENEO": "UNIVERSITY",
      "TOP MENU CORSI E MASTER": "ACADEMICS",
      "TOP MENU RICERCA": "RESEARCH",
      "TOP MENU ENTRA IN LUISS": "ADMISSIONS",

      "HOME PAGE apply button label": "Apply@Luiss",
      "HOME PAGE apply button url": "/how-to-apply",

      "HOME PAGE mobile card button": "Find out more",

      "HOME PAGE message label":
        "<p class='orange' style='text-decoration: underline;'>Learn Here To Stay Disruptive</p>",
      "HOME PAGE message title": "Face your future!",
      "HOME PAGE message footer": "Apply before July 20!",
      "HOME PAGE message content":
        "<span class='orange'>Admissions Test</span><br />for Bachelor’s and<br />Single-cycle master’s programs",
      "HOME PAGE message link":
        "https://www.luiss.it/entra-luiss/ammissione-triennali-e-ciclo-unico?_ga=2.245111173.1693127347.1618523614-1532339786.1609604213",

      "SCHOLARSHIP PAGE open luiss learn": "Open in Luiss Learn",

      "FOOTER link guida label": "Site Guide",
      "FOOTER link diversamente abili label": "Special Learning Support",
      "FOOTER link sitemap label": "Sitemap",
      "FOOTER link servizi label": "Web services",
      "FOOTER link elearning label": "E-learning",
      "FOOTER link cookie label": "Privacy Policy",
      "FOOTER link statistiche label": "Web Traffic",
      "FOOTER link antiphishing label": "Anti-Phishing",
      "FOOTER link logo label": "Brand Identity",
      "FOOTER link merchandising label": "Luiss Shop",
      "FOOTER link magazine label": "LMDP",
      "FOOTER link contatti label": "Contact Information",
      "FOOTER link 5x1000 label": "5x1000",
      "FOOTER link crediti label": "Credits",
      "FOOTER link feedback label": "Feedback",
      "FOOTER link dove siamo label": "Where we are",
      "FOOTER link campus label": "Campus life",
      "FOOTER link accommodation label": "Accommodation",

      "FOOTER link aree riservate label": "RESTRICTED AREAS",
      "FOOTER link ufficio stampa label": "PRESS OFFICE",
      "FOOTER link sostieni il merito label": "FUNDRAISING",

      "FOOTER link guida url": "/guide-navigating-luiss-website",
      "FOOTER link diversamente abili url":
        "/students/tutoring-academic-gym/special-learning-support",
      "FOOTER link sitemap url": "/sitemap-page",
      "FOOTER link servizi url": "/it-services/web-services",
      "FOOTER link elearning url": "https://learn.luiss.it",
      "FOOTER link cookie url": "/privacy-policy",
      "FOOTER link statistiche url": "/it-services/website-traffic",
      "FOOTER link antiphishing url": "/it-services/antiphishing",
      "FOOTER link logo url": "https://manualeidentita.luiss.it/",
      "FOOTER link merchandising url": "https://www.luissshop.it/",
      "FOOTER link magazine url": "https://luissuniversitypress.it/la-meraviglia-del-possibile/",
      "FOOTER link contatti url": "/contact-information",
      "FOOTER link 5x1000 url": "/fundraising/5x1000",
      "FOOTER link crediti url": "/credits",
      "FOOTER link feedback url": "/aree-riservate/front-office-services",
      "FOOTER link dove siamo url": "/where-we-are",
      "FOOTER link campus url": "/campus-life-eng",
      "FOOTER link accommodation url":
        "/students/residences-and-accommodation/residences-and-accommodation",

      "FOOTER link aree riservate url": "/restricted-areas",
      "FOOTER link ufficio stampa url":
        "https://www.luiss.it/media/press-office",
      "FOOTER link sostieni il merito url": "/fundraising ",

      "FOOTER text APP DOWNLOAD":
        " Download the Luiss app, it helps you in your educational and training experience.",
      "FOOTER text CREDITS":
        "PRIVACYCREDITS © " +
        new Date().getFullYear() +
        " Luiss Guido Carli - Viale Pola 12, 00198 Roma, Italia – Contact Center T 06 852251 – VAT number 01067231009.",

      "EVENT PAGE from date": "from",
      "EVENT PAGE to date": "to",
      "EVENT PAGE time": "at",

      "NOT FOUND PAGE title": "Error 404",
      "NOT FOUND PAGE backlink label": "Go to homepage",
      "NOT FOUND PAGE subtitle": "Sorry, the requested page is not available.",

      "NOT FOUND TRANSLATION title": "Error 404",
      "NOT FOUND TRANSLATION backlink label": "Go to the italian version",
      "NOT FOUND TRANSLATION subtitle":
        "Sorry, the requested page is not available in English.",

      "CA image card cta label": "Find out more",

      "C5 news cta label": "Open the news",

      "C8 timeline person from": "from",
      "C8 timeline person to": "to",

      "C15 name": "Useful documents",
      "C15 size": "Size",

      "C16 button view profile": "View profile",
      "C17 button view profile": "View profile",

      "C22 - Application Deadline": "APPLICATION DEADLINE: ",
      "C22 - Recruitment Code": "RECRUITMENT CODE: ",

      "C26 table text ECTS": "ECTS",
      "C26 table text years": "YEARS",
      "C26 table text start date": "COURSES START DATE:",
      "C26 table text place": "PLACE:",

      "C28 - First Column": "EN COURSE",
      "C28 - Second Column": "EN SSD",
      "C28 - Third Column": "EN CREDITS",

      "C41 grid no content": "No content found",

      "C49 filters residenze": "",
      "C49 filters collegi": "",

      "C52 no content": "No News",

      "C57 open label": "Open",
      "C57 website label": "Open the website",

      "C69 no result": "No professors has been found",

      "C69 department placeholder": "Select by Department",
      "C69 department all": "All Departments",
      "C69 department 123": "Department of Business and Management",
      "C69 department 124": "Department of Economics and Finance",
      "C69 department 125": "Department of Law",
      "C69 department 126": "Department of Political Science",
      "C69 department 4421": "Graduate School",
      "C69 department 4422": "Undergraduate School",

      /*
      "C69 department all": "All Departments",
      "C69 department dim": "Department of Business and Management",
      "C69 department def": "Department of Economics and Finance",
      "C69 department dg": "Department of Law",
      "C69 department dsp": "Department of Political Science",
*/

      "C69 role placeholder": "Select by Position",
      "C69 role all": "All",
      "C69 role full": "Resident Faculty",
      "C69 role adjunct": "Adjunct Professors",
      "C69 role visiting": "Visiting Professors",
      "C69 role emeritus": "Emeriti",

      "C69 search placeholder": "Select by Name",

      "C70 no result": "No professors has been found",
      "C70 no filters": "Enter filters to search",

      "C70 area placeholder": "Find an expert in",
      "C70 keyword placeholder": "Search by keyword",
      "C70 name placeholder": "Search by name",

      "C72 card cta label": "Find out more",

      "C73 pagination load more": "Load more",
      "C73 no content": "No content",

      "C75 no result": "No results for: ",
      "C75 no filters": "Enter filters to search",

      "C75 search filter placeholder": "Search...",
      "C75 year filter allyear label": "All years",
      "C75 professors label": "Professors:",
      "C75 degree label": "Degree:",
      "C75 course channel": "",

      "C77 header general table": "Syllabus",
      "C77 header course code": "Course code",
      "C77 header sector": "General Discipline (SSD)",
      "C77 header total hours": "Total Workload",
      "C77 header teaching hours": "Total Lesson Hours",
      "C77 header teaching language": "Teaching Language",
      "C77 value english": "English",
      "C77 value italian": "Italian",
      "C77 header professors": "Professors",
      "C77 header courseyear": "Course Year",
      "C77 header semester": "Semester",
      "C77 header channel": "Partition of students",
      "C77 header credits": "Credits",

      "C77 header course formative objectives": "Instructional goals",
      "C77 header intended learning outcomes": "Intended learning outcomes",
      "C77 header prerequisites": "Prerequisites",
      "C77 header course content": "Course Contents",
      "C77 header reference books": "Reference Books",
      "C77 header teaching method": "Teaching Methods",
      "C77 header assessment method": "Assessment Method",
      "C77 header criteria deciding subject final paper":
        "Thesis assignment criteria",
      "C77 header program": "Extended Program And Reference Reading Material",
      "C77 header week": "On line and on campus lectures content",

      "C77 header sostenibilita content":
        "Does the syllabus cover sustainability topics?",

      "C75 Discount label": "Discount",
      "C75 Category filter": "Select a category",
      "C75 Discount filter": "Select a discount",
      "C75 no content": "No Agreements",

      "C77 Contacts": "Contacts",
      "C77 Phone": "Phone",
      "C77 Fax": "Fax",
      "C77 Email": "Email",
      "C77 Website": "Website",
      "C77 Address": "Address",
      "C90 Contact Us": "Contact Us",
      "C90 Ask": "Would you like to enroll in the",
      "C90 Course": " course",
      "C90 Description":
        "To receive further information, fill in the following form",
      "C90 Required": "Required",
      "C90 Invalid Mail Address": "Invalid email address",
      "C90 Invalid Digit": "Please, insert numbers",
      "C90 Min Length": "Insert at least 7 number",
      "C90 Invalid Char": "Please, insert characters",
      "C90 Name": "Name",
      "C90 Surname": "Surname",
      "C90 Select Country Study": "Select the country of study",
      "C90 Consent": "I declare that I have read the",
      "C90 Privacy": "privacy policy",
      "C90 Contact": "I agree to be contacted",
      "C90 Submit": "Submit",
      "C90 Success": "Message sent successfully",
      "C90 Error": "Oops, something went wrong! Try again later.",

      "C100 label contatti-cv": "Contacts&CV",
      "C100 label contatti": "Contacts",
      "C100 button biografia": "Biography",
      "C100 button insegnamenti": "Teachings",
      "C100 table title insegnamento": "Teaching",
      "C100 table title CFU": "CFU",
      "C100 title pubblicazioni": "Main Publications",
      "C100 search by pubblication": "Search by publication",
      "C100 sort pubblication by year": "Order by year",
      "C100 sort pubblication by year asc": "Ascending",
      "C100 sort pubblication by year desc": "Descending",
      "C100 filter by publication type": "Filter by publication type",
      "C100 filter by publication type all": "All",
      "C100 filter by publication type chapter": "Chapter",
      "C100 filter by publication type article": "Article",
      "C100 filter by publication type online-portal": "Online portal publication",
      "C100 filter by publication type book": "Book",
      "C100 filter by access type": "Filter by access type",
      "C100 filter by access type all": "All",
      "C100 filter by access type open": "Open",
      "C100 filter by access type partially-open": "Partially Open",
    
      "C100 label contatti-cv": "Contacts&CV",
      "C100 label contatti": "Contacts",
      "C100 button biografia": "Biography",
      "C100 button insegnamenti": "Teachings",
      "C100 table title insegnamento": "Teaching",
      "C100 table title CFU": "CFU",
      "C100 title pubblicazioni": "Main publications",
      "C100 search by pubblication": "Search by publication",
      "C100 sort pubblication by year": "Order by year",
      "C100 sort pubblication by year none": "No ordering",
      "C100 sort pubblication by year asc": "Ascending",
      "C100 sort pubblication by year desc": "Descending",
      "C100 filter by publication type": "Filter by publication type",
      "C100 filter by publication type all": "All",
      "C100 filter by publication type chapter": "Chapter",
      "C100 filter by publication type article": "Article",
      "C100 filter by publication type online-portal": "Online portal publication",
      "C100 filter by publication type book": "Book",
      "C100 filter by access type": "Filter by access type",
      "C100 filter by access type all": "All",
      "C100 filter by access type open": "Open",
      "C100 filter by access type partially-open": "Partially Open",
      "C100 title biography": "Biography",
      "C100 title teaching": "Teaching",
      "C100 title pubblication": "Main Publications",
      "C100 title research interests": "Research Interests",
      "C100 title contacts-cv": "Contacts&CV",
      "C100 button download current-cv": "Current CV (EN)",
      "C100 table title hours": "Hours",
    },
  },
  it: {
    translation: {
      "TOP MENU ATENEO": "ATENEO",
      "TOP MENU CORSI E MASTER": "CORSI E MASTER",
      "TOP MENU RICERCA": "RICERCA",
      "TOP MENU ENTRA IN LUISS": "ENTRA IN LUISS",

      "HOME PAGE apply button label": "Apply@Luiss",
      "HOME PAGE apply button url": "/ammissione",
      "HOME PAGE mobile card button": "Scopri di più",

      "HOME PAGE message label": "Prove di ammissione ai corsi di laurea",
      "HOME PAGE message title": "",
      "HOME PAGE message footer": "",
      "HOME PAGE message content": "",
      "HOME PAGE message link":
        "https://www.luiss.it/ammissione/ammissione-magistrali/test-ammissione-magistrali",

      "SCHOLARSHIP PAGE open luiss learn": "Apri in Luiss Learn",

      "FOOTER link guida label": "Guida al sito",
      "FOOTER link diversamente abili label": "Disabilità e DSA",
      "FOOTER link sitemap label": "Sitemap",
      "FOOTER link servizi label": "Servizi web",
      "FOOTER link elearning label": "E-learning",
      "FOOTER link cookie label": "Privacy Policy",
      "FOOTER link statistiche label": "Statistiche",
      "FOOTER link antiphishing label": "Anti-Phishing",
      "FOOTER link logo label": "Brand Identity",
      "FOOTER link merchandising label": "Luiss Shop",
      "FOOTER link magazine label": "LMDP",
      "FOOTER link contatti label": "Contatti",
      "FOOTER link 5x1000 label": "5x1000",
      "FOOTER link crediti label": "Crediti",
      "FOOTER link feedback label": "Feedback",
      "FOOTER link dove siamo label": "Dove siamo",
      "FOOTER link campus label": "Campus life",
      "FOOTER link accommodation label": "Accommodation",

      "FOOTER link aree riservate label": "AREE RISERVATE",
      "FOOTER link ufficio stampa label": "UFFICIO STAMPA",
      "FOOTER link sostieni il merito label": "SOSTIENI IL MERITO",

      "FOOTER link guida url": "/guida-composizione-navigazione-del-sito",
      "FOOTER link diversamente abili url":
        "/studenti/tutorato/seitu-servizio-inclusione-tutorato/disabilita-dsa",

      "FOOTER link sitemap url": "/sitemap-page",
      "FOOTER link servizi url": "/servizi-informatici/servizi-web",
      "FOOTER link elearning url": "https://learn.luiss.it",
      "FOOTER link cookie url": "/informativa-sulla-privacy",
      "FOOTER link statistiche url":
        "/servizi-informatici/dati-di-monitoraggio",
      "FOOTER link antiphishing url": "/servizi-informatici/antiphishing",
      "FOOTER link logo url": "https://manualeidentita.luiss.it/",
      "FOOTER link merchandising url": "https://www.luissshop.it/",
      "FOOTER link magazine url": "https://luissuniversitypress.it/la-meraviglia-del-possibile/",
      "FOOTER link contatti url": "/contatti",
      "FOOTER link 5x1000 url": "/sostieni-il-merito/5x1000",
      "FOOTER link crediti url": "/credits",
      "FOOTER link feedback url": "/aree-riservate/sportello-studenti",
      "FOOTER link dove siamo url": "/dove-siamo",
      "FOOTER link campus url": "/campus-life",
      "FOOTER link accommodation url":
        "/servizi-agli-studenti/residenze-e-alloggi",

      "FOOTER link aree riservate url": "/aree-riservate",
      "FOOTER link ufficio stampa url": "/media/press-office",
      "FOOTER link sostieni il merito url": "/sostieni-il-merito",

      "FOOTER text APP DOWNLOAD":
        "Scarica l’app Luiss, ti aiuterà nell’esperienza didattica e formativa.",
      "FOOTER text CREDITS":
        "PRIVACYCREDITS © " +
        new Date().getFullYear() +
        " Luiss Guido Carli - Viale Pola 12, 00198 Roma, Italia - Centralino T 06 852251 - P.IVA 01067231009",

      "EVENT PAGE from date": "dal",
      "EVENT PAGE to date": "al",
      "EVENT PAGE time": "ore",

      "NOT FOUND PAGE title": "Errore 404",
      "NOT FOUND PAGE subtitle":
        "Spiacenti, la pagina richiesta non è stata trovata.",
      "NOT FOUND PAGE backlink label": "Torna in homepage",

      "NOT FOUND TRANSLATION title": "Errore 404",
      "NOT FOUND TRANSLATION subtitle":
        "Spiacenti, la pagina richiesta non è disponibile in lingua Italiana.",
      "NOT FOUND TRANSLATION backlink label": "Vai alla pagina in inglese",

      "CA image card cta label": "Scopri di più",

      "C5 news cta label": "Leggi la notizia",

      "C8 timeline person from": "dal",
      "C8 timeline person to": "al",

      "C15 name": "Documenti Utili",
      "C15 size": "Dimensioni",

      "C16 button view profile": "Vedi il profilo",
      "C17 button view profile": "Vedi il profilo",

      "C22 - Application Deadline": "SCADENZA: ",
      "C22 - Recruitment Code": "CODICE CONCORSO: ",

      "C26 table text ECTS": "ECTS",
      "C26 table text years": "ANNI",
      "C26 table text start date": "INIZIO CORSI:",
      "C26 table text place": "LUOGO:",

      "C28 - First Column": "IT COURSE",
      "C28 - Second Column": "IT SSD",
      "C28 - Third Column": "IT CREDITS",

      "C41 grid no content": "Nessun contenuto trovato",

      "C49 filters residenze": "Residenze",
      "C49 filters collegi": "Collegi",

      "C52 no content": "Nessuna News",

      "C57 open label": "Scopri",
      "C57 website label": "Vedi il sito",

      "C69 no result":
        "Non sono stati trovati professori con i filtri indicati",

      "C69 department placeholder": "Seleziona per dipartimento",
      "C69 department all": "Tutti i Dipartimenti",
      "C69 department 123": "Dipartimento di Impresa e Management",
      "C69 department 124": "Dipartimento di Economia e Finanza",
      "C69 department 125": "Dipartimento di Giurisprudenza",
      "C69 department 126": "Dipartimento di Scienze Politiche",
      "C69 department 4421": "Graduate School",
      "C69 department 4422": "Undergraduate School",
/*
      "C69 department all": "Tutti i Dipartimenti",
      "C69 department dim": "Dipartimento di Impresa e Management",
      "C69 department def": "Dipartimento di Economia e Finanza",
      "C69 department dg": "Dipartimento di Giurisprudenza",
      "C69 department dsp": "Dipartimento di Scienze Politiche",
*/
      "C69 role placeholder": "Seleziona per ruolo",
      "C69 role all": "Qualsiasi ruolo",
      "C69 role full": "Resident Faculty",
      "C69 role adjunct": "Adjunct Professors",
      "C69 role visiting": "Visiting Professors",
      "C69 role emeritus": "Emeriti",
      "C69 search placeholder": "Cerca per nome",

      "C70 no result":
        "Non sono stati trovati professori con i filtri indicati",
      "C70 no filters": "Inserisci dei filtri per fare una ricerca",

      "C70 area placeholder": "Trova un esperto in",
      "C70 keyword placeholder": "Ricerca tramite parola chiave",
      "C70 name placeholder": "Cerca per nome",

      "C72 card cta label": "Scopri di più",

      "C73 pagination load more": "Carica Altro",
      "C73 no content": "Nessun contenuto",

      "C75 no result": "Nessun risultato per: ",
      "C75 no filters": "Inserisci dei filtri per fare una ricerca",

      "C75 search filter placeholder": "Cerca...",
      "C75 year filter allyear label": "Tutti gli anni",
      "C75 professors label": "Docenti:",
      "C75 degree label": "Corso di laurea:",
      "C75 course channel": "Canale",

      "C77 header general table": "Programma",
      "C77 header course code": "Codice corso",
      "C77 header sector": "General Discipline (SSD)",
      "C77 header total hours": "Ore totali",
      "C77 header teaching hours": "Ore d'insegnamento",
      "C77 header teaching language": "Lingua",
      "C77 value english": "Inglese",
      "C77 value italian": "Italiano",
      "C77 header professors": "Professori",
      "C77 header courseyear": "Anno",
      "C77 header semester": "Semestre",
      "C77 header channel": "Canale",
      "C77 header credits": "Crediti",

      "C77 header course formative objectives": "Obiettivi formativi",
      "C77 header intended learning outcomes":
        "Risultati di apprendimento attesi",
      "C77 header prerequisites": "Prerequisiti",
      "C77 header course content": "Contenuti del corso",
      "C77 header reference books": "Testi di riferimento",
      "C77 header teaching method": "Metodologie didattiche",
      "C77 header assessment method": "Modalità di verifica dell'apprendimento",
      "C77 header criteria deciding subject final paper":
        "Criteri per l'assegnazione dell'elaborato finale",
      "C77 header program":
        "Programma esteso e materiale didattico di riferimento",
      "C77 header week": "Contenuto sessioni on line e on campus",

      "C77 header sostenibilita content":
        "Il syllabus affronta temi collegati alla sostenibilità?",

      "C75 Discount label": "Sconto",
      "C75 Category filter": "Seleziona una categoria",
      "C75 Discount filter": "Seleziona una sconto",
      "C75 no content": "Nessuna Convenzioni",

      "C77 Contacts": "Contatti",
      "C77 Phone": "Telefono",
      "C77 Fax": "Fax",
      "C77 Email": "Email",
      "C77 Website": "Sito web",
      "C77 Address": "Indirizzo",
      "C90 Contact Us": "Contattaci",
      "C90 Ask": "Sei interessato ad iscriverti al corso di",
      "C90 Course": "",
      "C90 Description":
        "Per ricevere ulteriori informazioni, compila il seguente form",
      "C90 Required": "Richiesto",
      "C90 Invalid Mail Address": "Indirizzo mail non valido",
      "C90 Invalid Digit": "Inserire caratteri numerici",
      "C90 Min Length": "Inserire almeno 7 numeri",
      "C90 Invalid Char": "Inserire caratteri validi",
      "C90 Name": "Nome",
      "C90 Surname": "Cognome",
      "C90 Select Country Study": "Seleziona il paese di studio",
      "C90 Consent": "Dichiaro di aver preso visione dell'",
      "C90 Privacy": "informativa privacy",
      "C90 Contact": "Acconsento ad essere ricontattato",
      "C90 Submit": "Invia",
      "C90 Success": "Messaggio inviato con successo",
      "C90 Error": "Ops, qualcosa è andato storto! Riprova più tardi.",

      "C100 label contatti-cv": "Contatti & CV",
      "C100 label contatti": "Contatti",
      "C100 button biografia": "Biografia",
      "C100 button insegnamenti": "Insegnamenti",
      "C100 table title insegnamento": "Insegnamento",
      "C100 table title CFU": "CFU",
      "C100 title pubblicazioni": "Principali Pubblicazioni",
      "C100 search by pubblication": "Cerca per pubblicazioni",
      "C100 sort pubblication by year": "Ordina anno",
      "C100 sort pubblication by year none": "Nessun ordinamento",
      "C100 sort pubblication by year asc": "Ascendente",
      "C100 sort pubblication by year desc": "Discendente",
      "C100 filter by publication type": "Filtra per tipo pubblicazione",
      "C100 filter by publication type all": "Tutti",
      "C100 filter by publication type chapter": "Capitolo",
      "C100 filter by publication type article": "Articolo",
      "C100 filter by publication type online-portal": "Pubblicazione su portale online",
      "C100 filter by publication type book": "Libro",
      "C100 filter by access type": "Filtra per tipo di accesso",
      "C100 filter by access type all": "Tutti",
      "C100 filter by access type open": "Open",
      "C100 filter by access type partially-open": "Partially Open",
      "C100 title biography": "Biografia",
      "C100 title teaching": "Insegnamenti",
      "C100 title pubblication": "Principali Pubblicazioni",
      "C100 title research interests": "Interessi di ricerca",
      "C100 title contacts-cv": "Contatti&CV",
      "C100 button download current-cv": "Current CV (ITA)",
      "C100 table title hours": "Ore",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init(
    {
      resources,
      lng: HIGH_LEVEL_CONFIG.DEFAULT_LANGUAGE,

      keySeparator: false, // we do not use keys in form messages.welcome

      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    },
    (err) => {
      if (err) {
        console.error("Error loading translation files", err);
      }
    }
  );

export default i18n;
